// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3Sq6t","icon":"SortAdornment_icon__31LWs","up":"SortAdornment_up__2eroF","down":"SortAdornment_down__3fHhI","active":"SortAdornment_active__pVcax"};